import React from 'react';

import { useIntl } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { FieldCheckbox } from '../../components';

import css from './AddOnCheckboxes.module.css';

const { Money } = sdkTypes;

/**
 * Renders checkboxes for listing add-ons in the order form.
 *
 * @param {Object} props
 * @param {string} props.formId - form ID prefix for checkbox IDs
 * @param {Array} props.addOns - array of { name, price: { amount, currency } }
 */
const AddOnCheckboxes = ({ formId, addOns }) => {
  const intl = useIntl();

  if (!addOns || addOns.length === 0) {
    return null;
  }

  return (
    <div className={css.root}>
      {addOns.map((addOn, index) => {
        const { name, price } = addOn;
        const formattedPrice = formatMoney(intl, new Money(price.amount, price.currency));
        const label = `${name}: ${formattedPrice}`;

        return (
          <div className={css.addOn} key={index}>
            <FieldCheckbox
              className={css.checkbox}
              id={`${formId}${name}`}
              name={`addOns.${name}`}
              label={label}
              value={name}
            />
          </div>
        );
      })}
    </div>
  );
};

export default AddOnCheckboxes;
